import React from 'react';
import './skills.css';
import AWS from "../../resources/cloudComputing.png"
import Dev from "../../resources/SoftwareDeveloper.png"
import QA from "../../resources/QA.png"
import Leadership from "../../resources/leadership.png"

const Skills = () => {
    return(
        <section id='skills'>
            <span className="skillTitle">About Me</span>
            <span className="SkillDesc">With a track records of success in diverse projects at WestJet and Verisk (an InsurTech company), I bring a multifaceted skillset combining development, SDET expertise, and leadership. I'm adept at utilizing my problem-solving skills and strong communication abilities to drive high-quality deliverables while fostering collaborative environments. My technical background includes expertise in developing highly available .NET microservices utilizing IoT-based telemetry data and deploying them within the cloud.</span>
            <div className="skillBars">
                <div className="skillBar">
                <img src={AWS} alt="AWS" className="skillBarImg" / >
                    <div className="skillBarText">
                        <h2>Cloud enthusiast</h2>
                        <p>I am a dedicated cloud technology enthusiast with practical, hands-on experience in real-world industry environments. My expertise is backed by multiple certifications, including two AWS Associate-level credentials—AWS Certified Developer and AWS Certified Solutions Architect—as well as Microsoft Azure certifications in Fundamentals (AZ-900) and AI Fundamentals (AI-900).</p>
                    </div>
                </div>
                <div className="skillBar">
                <img src={Dev} alt="SoftwareDevelopment" className="skillBarImg" / >
                    <div className="skillBarText">
                        <h2>Software Developer</h2>
                        <p>I have worked as a developer in various frontend and backend technologies. I worked with numerous developers, QA and product owners to plan and deliver well tested and architected products.</p>
                    </div>
                </div>
                <div className="skillBar">
                <img src={QA} alt="QA" className="skillBarImg" / >
                    <div className="skillBarText">
                        <h2>Quality Assurance</h2>
                        <p>My experience as a QA Engineer includes extensive work on data-intensive projects within the IoT domain. I have actively participated in ensuring the quality of data ingestion pipelines, scoring models, and insurance-ready data sets. Additionally, I have demonstrably built several test automation frameworks that seamlessly integrate with CI/CD pipelines, further enhancing the efficiency and reliability of the software development lifecycle.</p>
                    </div>
                </div>
                <div className="skillBar">
                <img src={Leadership} alt="QA" className="skillBarImg" / >
                    <div className="skillBarText">
                        <h2>Leadership</h2>
                        <p>In my role as Associate Engineering Manager, I provided leadership and direction to a team of 14 developers and QA professionals, fostering a culture of ownership and empowering them to manage their workflows autonomously.</p>
                    </div>
                </div>
                
            </div>
        </section>
    )
}

export default Skills;